import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import {  useNavigate } from "react-router-dom";
import { ContentsSection,  PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem, ToggleBtn } from "component/basic/btns";
import { CustomSelect } from "component/basic/formItems";
import { DotText, FixedPage, FixedSection } from "component/basic";
import { FixedContents, PopupCaptionDotTextBox } from "component/product/page";
import { MypageContentsBox, MypageControll, MypageSetItem, MypageSetItemArea, MypageSetItemSubArea, PageContentsSection, PopupBasicCaption } from "component/mypage/items";
import { appType } from "js/function";

const Setting = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [submitChk,setSubmitChk] =  useState(true);

    const pageDataApi = useGet({
        url:`/setting`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.setting;

    const [version,setVersion] =  useState(null);

    const [alarmData,setAlarmData] =  useState({
        use_alarm : 0,
        service_alarm : 0,
        event_alarm : 0,
        coupon_alarm : 0,
        news_alarm : 0
    });

    const [btnChk,setBtnChk] =  useState(true);
    const [withdrawalText,setWithdrawalText] =  useState(null);
    const [withdrawalPopupData,setWithdrawalPopupData] =  useState(null);

    function alarmDataCh(key,val){
        let oldData = {...alarmData};
        oldData[key] = val;
        setAlarmData(oldData);
    }

    function alarmChFunc(type,chk){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);

            let formData = new FormData();
            formData.append("type", type);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/setting/alarm/modify`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);
                },
                err: (apiData) => {
                    alarmDataCh(type,chk == 1 ? 0 : 1);
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    function withdrawalPopupOpen(){
        setWithdrawalText(null);
        setWithdrawalPopupData({
			addClass:null,
			title:"회원 탈퇴",
			closeType:true,
			closeFunc:(e) => {setWithdrawalPopupData(null)}
		});
    }

    function withdrawalPopupClose(){
        setWithdrawalText(null);
        setWithdrawalPopupData(null);
    }

    function withdrawalFunc(type){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);

            let formData = new FormData();
            formData.append("reason", withdrawalText);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/withdrawal`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);

                    window.errPopupOpen({
                        alert:`회원 탈퇴 완료`,
                        data:`회원 탈퇴가 완료되었습니다.<br/>이용해 주셔서 감사합니다.`,
                        closeType:false,
                        func:()=>{
                            window.logOut();
                        }
                    });

                    setTimeout(() => {                    
                        window.logOut();
                    }, 5000);
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    window.appVersion = (varsion) => {
        setVersion(varsion);
    };

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    useEffect(() => {
        if(pageData){
            let oldData = {...alarmData};
            oldData.use_alarm = pageData?.use_alarm;
            oldData.service_alarm = pageData?.service_alarm;
            oldData.event_alarm = pageData?.event_alarm;
            oldData.coupon_alarm = pageData?.coupon_alarm;
            oldData.news_alarm = pageData?.news_alarm;
            setAlarmData(oldData);

            if(appType() === "Android"){
                window.arentacarhub.versionCheck();
            }else if(appType() === "iOS"){
                window.webkit.messageHandlers.versionHandler.postMessage("version");
            }else{
                setVersion(pageDataApi?.data?.version);
            }
        }
    }, [pageDataApi]);

    useEffect(() => {
        if(withdrawalText){
            setBtnChk(false);
        }else{
            setBtnChk(true);
        }
    }, [withdrawalText]);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"설정"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={3}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min pcItemT"
                        addClass="nonFixed fixedsection_min"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <MypageControll
                            addClass="pcItemT"
                            data={null}
                        />
                    </FixedSection>
                    <FixedContents addClass="mypageFixedContents">
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="설정"
                        />
                        <PageContentsSection addClass="">
                            <MypageContentsBox
                                nPadding={true}
                                title={null}
                            >
                                <MypageSetItemArea>
                                    <MypageSetItem
                                        title={"PUSH 알림"}
                                        subTitle={"앱 이용 시 PUSH 알림 발송 여부"}
                                    >
                                        <ToggleBtn
                                            checkedType={alarmData?.use_alarm}
                                            chkFunc={(e)=>{
                                                alarmDataCh("use_alarm",e ? 1 : 0);
                                                alarmChFunc("use_alarm",e ? 1 : 0);
                                            }}
                                            id={"use_alarm"}
                                        />
                                    </MypageSetItem>
                                </MypageSetItemArea>
                                <MypageSetItemArea>
                                    <MypageSetItemSubArea>
                                        <MypageSetItem
                                            title={"결제 · 예약 알림"}
                                            subTitle={"결제 · 예약 등 서비스 관련 알림 발송 여부"}
                                        >
                                            <ToggleBtn
                                                checkedType={alarmData?.service_alarm}
                                                chkFunc={(e)=>{
                                                    alarmDataCh("service_alarm",e ? 1 : 0);
                                                    alarmChFunc("service_alarm",e ? 1 : 0);
                                                }}
                                                id={"service_alarm"}
                                            />
                                        </MypageSetItem>
                                        <MypageSetItem
                                            title={"이벤트 알림"}
                                            subTitle={"서비스 이벤트 및 혜택 제공 시 알림 발송 여부"}
                                        >
                                            <ToggleBtn
                                                checkedType={alarmData?.event_alarm}
                                                chkFunc={(e)=>{
                                                    alarmDataCh("event_alarm",e ? 1 : 0);
                                                    alarmChFunc("event_alarm",e ? 1 : 0);
                                                }}
                                                id={"event_alarm"}
                                            />
                                        </MypageSetItem>
                                    </MypageSetItemSubArea>
                                    <MypageSetItemSubArea>
                                        <MypageSetItem
                                            title={"쿠폰 · 포인트 알림"}
                                            subTitle={"이벤트 지급한 쿠폰 · 포인트 발급 시 알림 발송 여부"}
                                        >
                                            <ToggleBtn
                                                checkedType={alarmData?.coupon_alarm}
                                                chkFunc={(e)=>{
                                                    alarmDataCh("coupon_alarm",e ? 1 : 0);
                                                    alarmChFunc("coupon_alarm",e ? 1 : 0);
                                                }}
                                                id={"coupon_alarm"}
                                            />
                                        </MypageSetItem>
                                        <MypageSetItem
                                            title={"새소식 · 공지사항 알림"}
                                            subTitle={"서비스 중요 공지사항 발생 시 알림 발송 여부"}
                                        >
                                            <ToggleBtn
                                                checkedType={alarmData?.news_alarm}
                                                chkFunc={(e)=>{
                                                    alarmDataCh("news_alarm",e ? 1 : 0);
                                                    alarmChFunc("news_alarm",e ? 1 : 0);
                                                }}
                                                id={"news_alarm"}
                                            />
                                        </MypageSetItem>
                                    </MypageSetItemSubArea>
                                </MypageSetItemArea>
                                <MypageSetItemArea>
                                    <MypageSetItem
                                        title={"버전 정보"}
                                        subTitle={null}
                                    >
                                        <span className="wbTextColor">ver {version||"-"}</span>
                                    </MypageSetItem>
                                </MypageSetItemArea>
                                <MypageSetItemArea>
                                    <MypageSetItem
                                        title={"서비스 이용 약관"}
                                        subTitle={null}
                                        func={()=>{window.termsPopupOpen("service","서비스 이용 약관")}}
                                    />
                                    <MypageSetItem
                                        title={"개인정보 수집 및 이용 동의"}
                                        subTitle={null}
                                        func={()=>{window.termsPopupOpen("privacy","개인정보 수집 및 이용 동의")}}
                                    />
                                    <MypageSetItem
                                        title={"이벤트 및 혜택 정보 수신 동의"}
                                        subTitle={null}
                                        func={()=>{window.termsPopupOpen("event","이벤트 및 혜택 정보 수신 동의")}}
                                    />
                                    <MypageSetItem
                                        title={"회원 탈퇴"}
                                        subTitle={null}
                                        func={()=>{withdrawalPopupOpen()}}
                                    />
                                </MypageSetItemArea>
                            </MypageContentsBox>
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <CustomPopup data={withdrawalPopupData} basicPB={false} mSize={true}>
                <p className="withdrawalPopupText">A 렌터카 허브 회원을 탈퇴하시겠습니까?<br/>탈퇴 시 <b>지급받은 포인트 및 쿠폰 등 혜택</b>이 모두 삭제되며 삭제된 데이터는 복구되지 않습니다.</p>
                <CustomSelect
                    boxAddClass=""
                    addClass="absoluteSel"
                    inputName="탈퇴 사유 선택"
                    placeholder="사유를 선택해주세요"
                    value={withdrawalText}
                    func={(name,val) => {
                        setWithdrawalText(val)
                    }}
                    disabled={false}
                    valKey="id"
                    nameKey="id"
                    options={[
                        {id:"개인정보 삭제 목적"},
                        {id:"더 이상 서비스를 이용하지 않음"},
                        {id:"더 저렴한 타 플랫폼 이용"},
                        {id:"서비스 이용 불편"}
                    ]}
                />
                <PopupBasicCaption
                    text="<b>[개인정보 보존기간]</b><br/>계약 또는 청약철회 등에 관한 기록 : 5년<br/>결제 및 재화 등의 공급에 의한 기록 : 5년<br/>소비자 불만 및 분쟁처리에 관한 기록 : 5년<br/>웹사이트 방문기록 : 3개월"
                />
                <PopupCaptionDotTextBox addClass="notOp">
                    <DotText text={"회원 탈퇴 시, 서비스 이용 기록은 30일 이후 모두 삭제되며, 작성된 게시물은 삭제되지 않습니다."}/>
                    <DotText text={"전자상거래법, 통신비밀보호법 등 관련 법령에 의거해 일정 기간동안 개인정보가 보관됩니다."}/>
                </PopupCaptionDotTextBox>
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"취소"}
                        func={() => {
                            withdrawalPopupClose();
                        }}
                    />
                    <BtnItem
                        addClass=""
                        contents={"회원 탈퇴하기"}
                        disabled={btnChk}
                        func={() => {
                            withdrawalFunc();
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Setting;